// Web Crypto-based random nonce generator for OAuth flows

/**
 * generateNonce: generates a URL-safe random nonce using Web Crypto API
 *
 * @return {string} Base64url-encoded random string (≥32 chars)
 */
export const generateNonce = () => {
  const bytes = new Uint8Array(32)
  // eslint-disable-next-line no-undef
  globalThis.crypto.getRandomValues(bytes)
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}
